var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/img/HeartHome.jsx";

import React from 'react';
import PropTypes from 'prop-types';

var HeartHome = function HeartHome(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    width: "44",
    height: "44",
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.919 4.00001C19.5477 3.99517 19.1867 4.122 18.9 4.35801L5.01899 17.549C4.40942 18.135 4.04519 18.9307 3.99999 19.775V40.643C3.99599 40.9989 4.13356 41.3419 4.38242 41.5964C4.63129 41.8509 4.97107 41.9961 5.32699 42H34.511C34.8669 41.9961 35.2067 41.8509 35.4556 41.5964C35.7044 41.3419 35.842 40.9989 35.838 40.643V19.775C35.7928 18.9307 35.4286 18.135 34.819 17.549L20.938 4.35801C20.6512 4.12215 20.2903 3.99534 19.919 4.00001Z",
    fill: "#A6E5FF",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.906 2.33902C24.1857 2.11497 24.5346 1.99512 24.893 2.00002C25.2516 1.99531 25.6008 2.11512 25.881 2.33902L39.334 14.836C39.9225 15.3856 40.2764 16.1411 40.322 16.945V36.714C40.322 37.4243 39.7462 38 39.036 38H10.75C10.409 38 10.082 37.8645 9.84101 37.6233C9.6 37.3821 9.46473 37.055 9.465 36.714V16.948C9.51018 16.144 9.86413 15.3884 10.453 14.839L23.906 2.33902ZM37.584 16.72L24.893 4.93202L12.198 16.724L12.147 16.771C12.0992 16.8445 12.0619 16.9243 12.036 17.008V35.429H37.746V17.004C37.7201 16.9203 37.6828 16.8405 37.635 16.767L37.584 16.72Z",
    fill: "#0D4599",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.733 31.855C24.0505 32.115 24.4486 32.2564 24.859 32.255C25.3315 32.2499 25.7872 32.0786 26.146 31.771L32.254 25.679C33.3031 24.6322 33.8927 23.2111 33.8927 21.729C33.8927 20.247 33.3031 18.8258 32.254 17.779C30.2646 15.8035 27.123 15.5978 24.893 17.297C22.6632 15.5984 19.5222 15.8041 17.533 17.779C16.4834 18.8256 15.8935 20.2468 15.8935 21.729C15.8935 23.2112 16.4834 24.6325 17.533 25.679L23.733 31.855ZM19.349 19.595C19.9168 19.0282 20.6867 18.7105 21.489 18.712C22.2917 18.7095 23.0624 19.0265 23.631 19.593L24.896 20.859L26.161 19.595C27.3453 18.419 29.2567 18.419 30.441 19.595C31.0069 20.1592 31.325 20.9255 31.325 21.7245C31.325 22.5236 31.0069 23.2899 30.441 23.854L24.9 29.389L19.349 23.854C18.7831 23.2899 18.465 22.5236 18.465 21.7245C18.465 20.9255 18.7831 20.1592 19.349 19.595Z",
    fill: "#0D4599",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.533 17.7741C19.5222 15.7991 22.6632 15.5934 24.893 17.2921C27.122 15.5918 30.2636 15.7958 32.254 17.7701C33.3031 18.8169 33.8927 20.238 33.8927 21.7201C33.8927 23.2021 33.3031 24.6233 32.254 25.6701L26.146 31.7621C25.7877 32.0711 25.332 32.2438 24.859 32.2501C24.4486 32.2515 24.0505 32.11 23.733 31.8501L17.533 25.6741C16.4834 24.6275 15.8935 23.2063 15.8935 21.7241C15.8935 20.2419 16.4834 18.8206 17.533 17.7741ZM24.9 29.3891L30.438 23.8541V23.8591C31.0039 23.2949 31.322 22.5287 31.322 21.7296C31.322 20.9305 31.0039 20.1642 30.438 19.6001C29.2537 18.424 27.3423 18.424 26.158 19.6001L24.896 20.8611L23.631 19.5951C22.447 18.4191 20.5359 18.4191 19.352 19.5951C18.7861 20.1592 18.468 20.9255 18.468 21.7246C18.468 22.5237 18.7861 23.2899 19.352 23.8541L24.9 29.3891Z",
    fill: "#0D4599",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.158 19.6L24.893 20.864L23.628 19.598C22.444 18.4221 20.5329 18.4221 19.349 19.598C18.7831 20.1622 18.465 20.9285 18.465 21.7275C18.465 22.5266 18.7831 23.2929 19.349 23.857L24.9 29.389L30.441 23.854C31.0069 23.2899 31.325 22.5236 31.325 21.7245C31.325 20.9255 31.0069 20.1592 30.441 19.595C29.255 18.4184 27.3413 18.4206 26.158 19.6Z",
    fill: "#F2A619",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 9
    }
  }));
};

HeartHome.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string
} : {};
HeartHome.defaultProps = {
  className: null
};
export default HeartHome;